import { Link } from 'expo-router';
import { Button, ButtonText } from '@/components/gluestack/button';
import { useTranslation } from 'react-i18next';
import { LicenseNoIcon } from '@hugeicons-pro/core-stroke-rounded';
import { MessageView } from './MessageView';

export function NotFoundContent() {
  const { t } = useTranslation();

  return (
    <MessageView type="warning" text={t('notFound.title')} icon={LicenseNoIcon}>
      <Link href="/" replace asChild>
        <Button variant="solid" className="mt-4">
          <ButtonText>{t('notFound.goHome')}</ButtonText>
        </Button>
      </Link>
    </MessageView>
  );
}
